import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import TabCampanhas from "./TabCampanhas";
import TabParceiros from "./TabParceiros";
import TabVouchers from "./TabVouchers";
import { APIClient } from "../../helpers/api_helper";
import { toast } from "react-toastify";

const apiClient = new APIClient();

const VoucherDashboard = () => {
  const [resumo, setResumo] = useState({
    campanhas: 0,
    vouchers_ativos: 0,
    parceiros: 0,
    resgates: 0,
  });

  const [activeTab, setActiveTab] = useState("campanhas");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchWidgetData = async () => {
      setLoading(true);
      try {
        const response = await apiClient.get("/vouchers/widgets");
        if (response?.sucesso) {
          setResumo(response.dados);
        } else {
          toast.error(response.mensagem || "Erro ao carregar dados dos widgets");
        }
      } catch (error) {
        console.error("Erro completo:", error);
        toast.error("Erro ao carregar dados dos widgets");
      }
      setLoading(false);
    };

    fetchWidgetData();
  }, []);

  document.title = "Painel de Vouchers | Painel Fort Exchange";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="mb-4">
            <Col md={3}>
              <Card className="border-0 shadow-sm bg-info bg-opacity-10">
                <CardBody>
                  <div className="text-info fw-semibold">Campanhas</div>
                  <div className="h3 mb-0 text-info">{resumo.campanhas}</div>
                </CardBody>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="border-0 shadow-sm bg-secondary bg-opacity-10">
                <CardBody>
                  <div className="text-secondary fw-semibold">
                    Vouchers Ativos
                  </div>
                  <div className="h3 mb-0 text-secondary">
                    {resumo.vouchers_ativos}
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="border-0 shadow-sm bg-primary bg-opacity-10">
                <CardBody>
                  <div className="text-primary fw-semibold">Parceiros</div>
                  <div className="h3 mb-0 text-primary">{resumo.parceiros}</div>
                </CardBody>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="border-0 shadow-sm bg-warning bg-opacity-10">
                <CardBody>
                  <div className="text-warning fw-semibold">Resgates</div>
                  <div className="h3 mb-0 text-warning">{resumo.resgates}</div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h5 className="mb-3 text-dark">Ações Rápidas</h5>
          <Row className="mb-4">
            <Col>
              <Button
                color="soft-info"
                className={classnames("me-2 fw-semibold", {
                  active: activeTab === "campanhas",
                })}
                onClick={() => setActiveTab("campanhas")}
              >
                Campanhas
              </Button>
              <Button
                color="soft-info"
                className={classnames("me-2 fw-semibold", {
                  active: activeTab === "parceiros",
                })}
                onClick={() => setActiveTab("parceiros")}
              >
                Parceiros
              </Button>
              <Button
                color="soft-info"
                className={classnames("fw-semibold", {
                  active: activeTab === "vouchers",
                })}
                onClick={() => setActiveTab("vouchers")}
              >
                Vouchers
              </Button>
            </Col>
          </Row>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="campanhas">
              <TabCampanhas />
            </TabPane>
            <TabPane tabId="parceiros">
              <TabParceiros />
            </TabPane>
            <TabPane tabId="vouchers">
              <TabVouchers />
            </TabPane>
          </TabContent>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default VoucherDashboard;
